<template lang="html">
  <div class="footer">
    <div class="max-width col-block">
      <div class="content" :class="{ 'col-block': windowWidth < 1199.9 }">
        <div>
          <a href="https://www.compassbioinfo.com" target="_blank">
            <img :src="require('../../assets/images/footer-compass-logo.svg')">
            <span>康百事生物資訊股份有限公司</span>
          </a>
          <i class="fa fa-trash" aria-hidden="true" :style="{ opacity: 0 }"></i>
          <a href="https://www.linkedin.com/company/compass-bioinformatics" target="_blank">
            <i class="fa fa-linkedin-square fa-fw" aria-hidden="true"></i>
          </a>
          <a href="https://www.facebook.com/compassbioinfo" target="_blank" >
            <i class="fa fa-facebook-official fa-fw" aria-hidden="true"></i>
          </a>
        </div>
        <a href="tel:886-3-5745009">
          <i class="fa fa-phone fa-flip-horizontal fa-fw" aria-hidden="true"></i>
          <span>+886-3-574-5009</span>
        </a>
        <a href="https://www.google.com/maps/search/?api=1&query=新竹市東區慈雲路118號17樓之10" target="_blank">
          <i class="fa fa-map-marker fa-fw" aria-hidden="true"></i>
          <span>新竹市東區慈雲路118號17樓之10</span>
        </a>
        <div>
          <a href="mailto:service@compassbioinfo.com">
            <i class="fa fa-envelope fa-fw" aria-hidden="true"></i>
          </a>
          <span>service@compassbioinfo.com</span>
        </div>
      </div>
      <div class="content">
        <div>Copyright © 2019 Compass Bioinformatics</div>
      </div>
    </div>
  </div>
</template>

<script>
import invisible from '../tool/invisible'
import responsitive from '../../mixins/responsitive'

export default {
  components: {
    invisible
  },
  mixins: [
    responsitive
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/layout/footer.vue